import { render, staticRenderFns } from "./ResponsiblePerson.vue?vue&type=template&id=1f964f81"
import script from "./ResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./ResponsiblePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports